import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export const faqs = [
  {
    question: 'How is LAJ Digital different from a traditional marketing agency?',
    answer: 'Traditional agencies often focus solely on marketing and outsource technical work. We are a unified team combining senior marketing strategists with experienced software developers. We don\'t just plan the strategy; we build the underlying technology, websites, and automations required to execute it flawlessly.'
  },
  {
    question: 'Do I have to use all of your services at once?',
    answer: 'Not at all. We conduct a Discovery phase to identify your specific bottlenecks. Whether you need a new website, a targeted SEO campaign, or a custom CRM implementation, we build a tailored roadmap that addresses your most critical needs first.'
  },
  {
    question: 'What exactly is the After Hours CallBot?',
    answer: 'It is an AI-powered voice assistant designed to answer calls when your team is unavailable. Instead of sending prospects to voicemail, the CallBot engages them, answers common questions, qualifies the lead, and can even schedule appointments—capturing revenue you would otherwise lose.'
  },
  {
    question: 'How long does it take to see results?',
    answer: 'It depends on the services deployed. Paid advertising (Google Ads) and AI Callbots can generate immediate results within days of launch. SEO, content marketing, and deep CRM integrations are long-term strategies that typically show significant momentum within 3 to 6 months.'
  },
  {
    question: 'Do you build custom software for internal operations?',
    answer: 'Yes. If off-the-shelf software doesn\'t fit your business model, our development team builds custom portals, workflow automations, and API integrations that connect your marketing data directly to your operational processes.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="section-padding relative bg-gray-950 border-t border-gray-800/50">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-16 relative z-10">
          <span className="text-cyan-400 font-medium tracking-widest text-sm uppercase mb-4 block font-display">
            Common Questions
          </span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
        </div>

        <div className="space-y-4 relative z-10">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className="glass-card rounded-2xl overflow-hidden border border-gray-800/60"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none"
                aria-expanded={openIndex === idx}
              >
                <span className="text-lg font-display font-medium text-gray-200 pr-8">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 bg-cyan-900/50 text-cyan-400' : 'text-gray-400'}`}>
                  <SafeIcon icon="FiChevronDown" className="text-xl" />
                </div>
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <div className="px-6 pb-6 pt-2 text-gray-400 font-light text-base leading-relaxed border-t border-gray-800/50 mt-2">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;